import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin.component';
import { AdminGuard } from './admin.guard';
import { AdminService } from './admin.service';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddUserComponent } from './add-user/add-user.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ChangeEmailComponent } from './change-email/change-email.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AdminResolver } from './admin.resolver';
import { SharedModule } from '../shared/shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { UserManagementComponent } from './user-management/user-management.component';
import { SheetComponent } from './sheet/sheet.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { CreateCurrencyPairComponent } from './sheet/create-currency-pair/create-currency-pair.component';

const routes: Routes = [
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AdminGuard],
    resolve: {
      preload: AdminResolver
    },
    children: [
      {
        path: 'currency-management',
        component: SheetComponent
      },
      {
        path: 'user-management',
        component: UserManagementComponent
      }
    ]
  }
];

@NgModule({
  declarations: [
    AdminComponent,
    AddUserComponent,
    ChangePasswordComponent,
    ChangeEmailComponent,
    UserManagementComponent,
    SheetComponent,
    CreateCurrencyPairComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    FormsModule,
    MatTableModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatIconModule,
    SharedModule,
    MatTabsModule,
    TabsModule,
    MatSidenavModule,
    MatListModule,
    NgxDatatableModule
  ],
  providers: [
    AdminService,
    AdminResolver
  ]
})
export class AdminModule {
}
